export function makeOrderedFieldPayload(list) {
  return (Array.isArray(list) ? list : [])
    .map((field) => ({ name: field?.name }))
    .filter((entry) => entry.name);
}

export function moveOrderedFieldByName(ordered, fromName, toName) {
  const currentOrder = Array.isArray(ordered) ? ordered : [];
  const fromIndex = currentOrder.findIndex((entry) => entry?.name === fromName);
  const toIndex = currentOrder.findIndex((entry) => entry?.name === toName);

  if (fromIndex < 0 || toIndex < 0) return null;

  const nextOrder = [...currentOrder];
  const [moved] = nextOrder.splice(fromIndex, 1);
  nextOrder.splice(toIndex, 0, moved);
  return nextOrder;
}

export function buildOverrideFieldsFromOrder({ ordered, resolvedFields, fields }) {
  const baseFields = Array.isArray(resolvedFields) && resolvedFields.length
    ? resolvedFields
    : fields;

  const byName = new Map((baseFields || []).map((field) => [field?.name, field]));
  const seen = new Set();
  const nextFields = [];

  (Array.isArray(ordered) ? ordered : []).forEach((entry) => {
    const name = entry?.name;
    if (!name || seen.has(name)) return;
    const existing = byName.get(name);
    if (!existing) return;
    nextFields.push({ ...existing });
    seen.add(name);
  });

  (baseFields || []).forEach((field) => {
    if (field?.name && !seen.has(field.name)) nextFields.push(field);
  });

  return nextFields;
}